const equipment = [
  {
    path: '/my-equipment',
    name: 'my-equipment',
    component: () => import(/* webpackChunkName: "myequipment" */ '@/pages/equipment/my-equipment'),
    meta: {
      login: true
      // titleBar: {
      //   title: '我的设备',
      //   hasMenu: true
      // }
    }
  },
  {
    path: '/bind-list',
    name: 'bind-list',
    component: () => import(/* webpackChunkName: "bindlist" */ '@/pages/equipment/bind-list'),
    meta: {
      login: true,
      titleBar: {
        title: '绑定设备',
        hasMenu: true
      }
    }
  },
  {
    path: '/bind-equipment',
    name: 'bind-equipment',
    component: () => import(/* webpackChunkName: "bindequipment" */ '@/pages/equipment/bind-equipment'),
    meta: {
      login: true,
      titleBar: {
        title: '血糖血压测量仪',
        hasMenu: true
      }
    }
  },
  {
    path: '/equipment-detail',
    name: 'equipment-detail',
    component: () => import(/* webpackChunkName: "equipmentdetail" */ '@/pages/equipment/equipment-detail'),
    meta: {
      login: true,
      titleBar: {
        title: '设备详情',
        hasMenu: true
      }
    }
  },
  {
    path: '/all-data',
    name: 'all-data',
    component: () => import(/* webpackChunkName: "alldata" */ '@/pages/equipment/all-data'),
    meta: {
      login: true
      // titleBar: {
      //   title: '所有数据',
      //   hasMenu: true
      // }
    }
  },
  {
    path: '/equipment-pdf',
    name: 'equipment-pdf',
    component: () => import(/* webpackChunkName: "equipmentpdf" */ '@/pages/equipment/pdf'),
    meta: {
      login: true,
      titleBar: {
        title: '检查报告',
        hasMenu: true
      }
    }
  },
  {
    path: '/detail-data',
    name: 'detail-data',
    component: () => import(/* webpackChunkName: "detaildata" */ '@/pages/equipment/detail-data'),
    meta: {
      login: true,
      titleBar: {
        title: '详细数据',
        hasMenu: true
      }
    }
  },
  {
    path: '/blood-pressure-detail',
    name: 'blood-pressure-detail',
    component: () => import(/* webpackChunkName: "bloodpressuredetail" */ '@/pages/equipment/blood-pressure-detail2'),
    meta: {
      login: true,
      titleBar: {
        title: '血压详情',
        hasMenu: true
      }
    }
  },
  {
    path: '/blood-glucose-detail',
    name: 'blood-glucose-detail',
    component: () => import(/* webpackChunkName: "bloodglucosedetail" */ '@/pages/equipment/blood-glucose-detail2'),
    meta: {
      login: true,
      titleBar: {
        title: '血糖详情',
        hasMenu: true
      }
    }
  },
  {
    path: '/temp-detail',
    name: 'temp-detail',
    component: () => import(/* webpackChunkName: "tempdetail" */ '@/pages/equipment/temp-detail'),
    meta: {
      login: true,
      titleBar: {
        title: '体温详情',
        hasMenu: true
      }
    }
  },
  {
    path: '/weight-detail',
    name: 'weight-detail',
    component: () => import(/* webpackChunkName: "weightdetail" */ '@/pages/equipment/weight-detail'),
    meta: {
      login: true,
      titleBar: {
        title: '体重详情',
        hasMenu: true
      }
    }
  },
  {
    path: '/heart-detail-bosheng',
    name: 'heart-detail-bosheng',
    component: () => import(/* webpackChunkName: "heartdetail" */ '@/pages/equipment/heart-detail'),
    meta: {
      login: true
      // titleBar: {
      //   title: '心电监护',
      //   hasMenu: true
      // }
    }
  },
  {
    path: '/heart-detail',
    name: 'heart-detail',
    component: () => import(/* webpackChunkName: "heartdetail" */ '@/pages/equipment/heart-detail'),
    meta: {
      login: true
      // titleBar: {
      //   title: '心电监护',
      //   hasMenu: true
      // }
    }
  },
  {
    path: '/heart-detail-data',
    name: 'heart-detail-data',
    component: () => import(/* webpackChunkName: "heartdetaildata" */ '@/pages/equipment/heart-detail-data'),
    meta: {
      login: true
    }
  },
  {
    path: '/cl-glucose',
    name: 'cl-glucose',
    component: () => import(/* webpackChunkName: "clglucose" */ '@/pages/equipment/cl-glucose'),
    meta: {
      login: true
    }
  },
  {
    path: '/uric-acids-detail',
    name: 'uric-acids-detail',
    component: () => import(/* webpackChunkName: "clglucose" */ '@/pages/equipment/uric-acids-detail'),
    meta: {
      login: true,
      titleBar: {
        title: '尿酸详情',
        hasMenu: true
      }
    }
  }
]

export default equipment
